export var siclI18nextBackend = {
  type: 'backend',
  init: function init(services, backendOptions, i18nextOptions) {},
  read: function read(language, namespace, callback) {
    var promise = function () {
      switch (namespace) {
        case 'sicl-common':
          switch (language) {
            case 'fi_FI':
              return import('../../i18n/fi_FI/sicl-common');
            case 'sv_SE':
              return import('../../i18n/sv_SE/sicl-common.json');
            case 'en_GB':
              return import('../../i18n/en_GB/sicl-common.json');
          }
      }
    }();
    if (promise) {
      promise.then(function (value) {
        callback(null, value.default);
      }).catch(function (reason) {
        callback(reason, false /* No retry */);
      });
    } else {
      callback(new Error("Unrecognized namespace/language ".concat(namespace, "/").concat(language)), false /* No retry */);
    }
  },
  create: function create() {
    // This is called when a missing translation is encountered.
  }
};